@if (formGroup) {
    <form class="grid-container grid-3" [formGroup]="formGroup">
        <div class="grid-row-1 grid-span-3 medium-margin-bottom">
            @if (formGroup.controls?.measures?.errors?.required) {
                <form-error errorToTranslate="ERRORS.FORM.REQUIRED" class="large-padding-left" />
            }
            @if (formGroup.controls?.measures?.errors?.differentUnits) {
                <form-error errorToTranslate="TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.ERROR.UNIT" class="large-padding-left" />
            }
            <path-list
                formArrayName="measures"
                [disableAdding]="!(availableMeasures$ | async)?.length || formGroup?.value?.measures.length >= 4 || disabled"
                (addClicked)="addMeasure(true)"
            >
                @for (filterControl of formGroup.controls.measures.controls; track filterControl; let i = $index) {
                    <path-list-item
                        [formGroupName]="i"
                        [disabled]="formGroup.value?.measures.length < 2 || disabled"
                        (removed)="removeMeasure(i)"
                    >
                        <div class="serie">
                            <ui-field class="selector" [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.SERIES' | translate">
                                <ui-select
                                    formControlName="measureCode"
                                    labelField="name"
                                    valueField="measureCode"
                                    [options]="availableMeasures$ | async"
                                    [disabled]="!(availableMeasures$ | async)?.length || disabled"
                                    [required]="true"
                                />
                            </ui-field>
                            <ui-icon-button-toggle
                                class="measure-config-item"
                                color="primary"
                                [options]="chartTypeOptions"
                                [ngModel]="filterControl.value.chartType"
                                [ngModelOptions]="{ standalone: true }"
                                (ngModelChange)="setChartType(filterControl, $event)"
                            />
                            @if (filterControl.value.measureCode | applyPureFunction: canMeasureBeCumulated$ | async) {
                                <ui-toggle
                                    class="measure-config-item"
                                    formControlName="isCumulative"
                                    [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.TOGGLE_ACCRUAL' | translate"
                                />
                            }
                            @if (filterControl.value.chartType === 'column') {
                                <ui-field
                                    class="selector"
                                    [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.STACKING_GROUP' | translate"
                                >
                                    <ui-select formControlName="columnStackingGroup" [options]="stackingGroupIds">
                                        <ng-template let-option="option">
                                            {{
                                                'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.GROUP_NAME'
                                                    | translate: { groupId: option }
                                            }}
                                        </ng-template>
                                    </ui-select>
                                </ui-field>
                            }

                            <!-- If the representation has both line and column, the lines are not segmented even if there is a segmentation -->
                            @if (
                                !formGroup.controls.segmentationDimensionCode.value ||
                                (filterControl.controls.chartType.value === 'line' && (hasAtLeastOneColumn$ | async))
                            ) {
                                <ui-color-picker formControlName="measureColor" controlValueAccessorInterop />
                            }
                        </div>
                    </path-list-item>
                }
            </path-list>
        </div>
        <ui-form-field class="grid-row-2" [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.X_AXIS' | translate">
            <ui-select
                formControlName="xAxisDimensionCode"
                labelField="name"
                valueField="dimensionCode"
                groupField="resourceTypeLabel"
                [options]="availableDimensions$ | async"
                [required]="true"
                [disabled]="!(availableDimensions$ | async)?.length || disabled"
            />
        </ui-form-field>
        @if (isXAxisTemporalDimension$ | async) {
            <ui-form-field class="grid-row-2" [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.STEP' | translate">
                <ui-select
                    formControlName="xAxisStepCode"
                    labelField="label"
                    valueField="value"
                    [options]="stepList"
                    [required]="true"
                    [disabled]="!stepList.length || disabled"
                    [sortFn]="doNotSort"
                />
            </ui-form-field>

            @if (currentStep$ | async | applyPureFunction: isStartAtAvailable) {
                <ui-form-field
                    class="grid-row-2"
                    [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.STEP_CUSTOM_MONTH.START_MONTH' | translate"
                >
                    <ui-select
                        formControlName="startAt"
                        [options]="months"
                        [disabled]="!months.length || disabled"
                        [sortFn]="doNotSort"
                        [clearable]="true"
                    >
                        <ng-template let-option="option">
                            {{ 'HIGHCHARTS.MONTHS.' + option.toString() | translate }}
                        </ng-template></ui-select
                    >
                </ui-form-field>
            }
        }
        @if (isMeasuresSegmentable$ | async) {
            <ui-form-field class="grid-row-3" [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.SEGMENTATION' | translate">
                <ui-select
                    formControlName="segmentationDimensionCode"
                    labelField="name"
                    valueField="dimensionCode"
                    groupField="resourceTypeLabel"
                    [options]="segmentationDimensions$ | async"
                    [disabled]="!(segmentationDimensions$ | async)?.length || disabled"
                    [clearable]="true"
                />
            </ui-form-field>
        }
    </form>
}
